import GlobalStoreService from "./global-store.service";
import ChatBotApiService from './chatbot-api.service';
import TrackingMiddlewareService from './tracking-middleware.service'
import UtilService from "./util.service";
import DBReadWriteService from "./db-read-write.service";
import { globalConstants } from "../constants/globalConstants";
import { SCRIPTS } from "../constants/staticScripts";
import TrackingKey from '../enums/trackingKey'
import BotType from "../enums/BotType";

export default class LoginService {

    static loginInApp() {

        GlobalStoreService.set('loginType', globalConstants.TRACKING_EVENTS_CONSTANTS.loginType.ALREADY_LOGGEDIN)

        return new Promise((resolveLoginInApp, rejectLoginInApp) => {

            let appReference = GlobalStoreService.get("APP_CONTEXT")

            const method = "GET";
            const uri =
                "https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";
            const payload = "";
            let appHeaders = appReference.getHeaders(
                method,
                uri,
                payload
            );

            appHeaders = String(appHeaders).replace(/\n/g, "");
            appHeaders = JSON.parse(appHeaders);
            const headers = {
                "x-bsy-dt": String(appHeaders["x-bsy-dt"]).replace(/\n/g, ""),
                "x-bsy-utkn1": String(appHeaders["x-bsy-utkn"]).replace(/\n/g, ""),
                "x-bsy-did": String(appHeaders["x-bsy-did"]).replace(/\n/g, "")
            };

            let newappHeaders = appReference.getHeaders(
                method,
                "https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch",
                ""
            );

            newappHeaders = String(newappHeaders).replace(/\n/g, "");
            newappHeaders = JSON.parse(newappHeaders);
            headers["x-bsy-utkn2"] = String(newappHeaders["x-bsy-utkn"]).replace(/\n/g, "");

            ChatBotApiService.getChatTokenForApp(headers).then((result) => {

                this.setLoginData(result);
                this.setTrackingLoginData(result);
                if (GlobalStoreService.get("currentBotType") !== BotType.PAYMENTS_BANK) {
                    this.handleUserProfile(result.userProfile)
                }
                else {
                    //in case of payments bank track login success without checking profile
                    TrackingMiddlewareService.trackEvent(TrackingKey.LOGIN_SUCCESS)
                }
                resolveLoginInApp();

            },
                err => {
                    // TRACK CHAT LAUNCH FAIL
                    TrackingMiddlewareService.trackEvent(TrackingKey.LOGIN_FAIL)
                    rejectLoginInApp();
                    return { status: err };
                });
        })
    }

    static loginInWeb(mobNo, loginType) {

        GlobalStoreService.set('loginType', loginType ? loginType : globalConstants.TRACKING_EVENTS_CONSTANTS.loginType.ALREADY_LOGGEDIN)

        return new Promise((resolveLoginInWeb, rejectLoginInWeb) => {

            ChatBotApiService.getChatTokenForWeb(mobNo).then((result) => {
                if (UtilService.allowUserLogin(result, mobNo)) {
                    GlobalStoreService.set("loginNotAllowed",false)
                    this.setLoginData(result);
                    this.setTrackingLoginData(result);
                    this.handleUserProfile(result.userProfile)
                }
                else{
                    GlobalStoreService.set("loginNotAllowed",true)
                }
                resolveLoginInWeb();
            }, err => {
                // TRACK CHAT LAUNCH FAIL
                TrackingMiddlewareService.trackEvent(TrackingKey.LOGIN_FAIL)
                rejectLoginInWeb();
            })
        })
    }


    static setLoginData(result) {

        GlobalStoreService.set("loggedInToken", "Bearer" + result.access_token);
        let primaryNumber = (result && result.userProfile && result.userProfile.userAuthToken && result.userProfile.userAuthToken.primaryMsisdn) ? result.userProfile.userAuthToken.primaryMsisdn : ""
        GlobalStoreService.set("primaryNumber", primaryNumber);
        GlobalStoreService.set("isUserLoggedIn", true);
        // do not set user profile if paymnets bank chatbot 
        if (GlobalStoreService.get("currentBotType") !== BotType.PAYMENTS_BANK) {

            if (result.userProfile) {
                GlobalStoreService.set("userProfile", result.userProfile);
            }
            if (result.userProfile && result.userProfile.products) {
                let numbers = UtilService.getUserProfileNumbersWithAccountType(result.userProfile);
                GlobalStoreService.set("userAccounts", numbers);
            }
            GlobalStoreService.set("currentBotType", UtilService.getBotType(primaryNumber, result.userProfile))
        }
    }

    static setTrackingLoginData(result) {
        const trackingData = GlobalStoreService.get("trackingData");

        trackingData.circle = (result &&
            result.userProfile &&
            result.userProfile.userAuthToken &&
            result.userProfile.userAuthToken.circle) ?
            result.userProfile.userAuthToken.circle : "";
        //update circle for tracking data
        GlobalStoreService.set("trackingData", trackingData);

        let primaryNumber = (result && result.userProfile && result.userProfile.userAuthToken && result.userProfile.userAuthToken.primaryMsisdn) ? result.userProfile.userAuthToken.primaryMsisdn : ""
        //NEW TRACKING
        TrackingMiddlewareService.setTrackingData({ circle: trackingData.circle })

    }

    static handleUserProfile(userProfile) {
        let primaryNumber = (userProfile && userProfile.userAuthToken && userProfile.userAuthToken.primaryMsisdn) ? userProfile.userAuthToken.primaryMsisdn : ""

        if (userProfile && userProfile.products) {

            TrackingMiddlewareService.trackEvent(TrackingKey.LOGIN_SUCCESS)

            if (UtilService.isSingleAccount(userProfile)) {
                GlobalStoreService.set('userProfileType', 'SINGLE')
                //SET CURRENT NUMBER TO PRIMARY NUMBER IN SINGLE ACCOUNT CASE
                GlobalStoreService.set("currentNumber", primaryNumber);
                TrackingMiddlewareService.trackEvent(TrackingKey.SSO_PROFILE_SINGLE)

            }
            else if (UtilService.isMultipleAccount(userProfile)) {
                GlobalStoreService.set('userProfileType', 'MULTIPLE')
                TrackingMiddlewareService.setTrackingForSSOMultiple(userProfile)
                TrackingMiddlewareService.trackEvent(TrackingKey.SSO_PROFILE_MULTIPLE)

            }
            else {
                //TRACK SSO PROFILE NO ACCOUNT
                GlobalStoreService.set("loggedInToken", null);
                GlobalStoreService.set("isUserLoggedIn", false)
                TrackingMiddlewareService.trackEvent(TrackingKey.SSO_PROFILE_NO_ACCOUNT)
            }
        }
        else {
            //TRACK LOGIN FAILURE
            GlobalStoreService.set("loggedInToken", null);
            GlobalStoreService.set("isUserLoggedIn", false)
            TrackingMiddlewareService.trackEvent(TrackingKey.LOGIN_FAIL)
        }
    }

    static afterInitialLoginSuccess({ message_comp }) {

        if (GlobalStoreService.get('currentBotType') === BotType.PAYMENTS_BANK) {
            //if payments bank initiate welcome scenario for payments bank
            GlobalStoreService.set("currentNumber", GlobalStoreService.get("primaryNumber"))
            message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject('Welcome to Airtel Payments Bank – Online Chat Support!')] })
            message_comp.initiateWelcomeScenario();
        }

        else if (window.MyAirtelChatAppReact) {
            //app new context supporting chat history
            //read the message chat history from db
            DBReadWriteService.readFromDB();

        }
        else if (GlobalStoreService.get("APP_CONTEXT")) {
            //app old context
            switch (GlobalStoreService.get('userProfileType')) {
                case 'SINGLE': {

                    message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME)] })
                    message_comp.onNumberSelected({ user_response: GlobalStoreService.get('primaryNumber'), show_number: false });
                    break
                }
                case 'MULTIPLE': {
                    message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
                    message_comp.setLoaderOff();
                    message_comp.addNewMessages({
                        new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME),
                        UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT)]
                    })
                    break
                }
            }
        }
        else {
            //web case
            switch (GlobalStoreService.get('userProfileType')) {
                case 'SINGLE': {
                    const chatItem = globalConstants.CONFIRMATION_FOR_SINGLE_ACCOUNT_WEB;
                    chatItem.response = chatItem.response.replace(
                        "moblieNumbetPlaceholder",
                        GlobalStoreService.get('primaryNumber')
                    );
                    message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME), UtilService.createChatBotMessageObject(chatItem.response)] })

                    message_comp.setState({
                        current_scenario: chatItem,
                        showFeedbackOptions: false,
                        response_options: chatItem,
                        disableBottomBar: true
                    });
                    message_comp.setLoaderOff();
                    break
                }
                case 'MULTIPLE': {
                    message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
                    message_comp.setLoaderOff();
                    message_comp.addNewMessages({
                        new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME),
                        UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT)]
                    })


                    // WHEN AVATAR OF BOT WILL BE RELEASED
                    // message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME,messageTime:UtilService.getCurrentTime()}]})
                    break
                }
                default: {
                    // not logged in case
                    message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME)] })
                    message_comp.initiateWelcomeScenario();
                }
            }
        }
    }

    static afterLoginAtALaterStage({ message_comp }) {

        if (GlobalStoreService.get("APP_CONTEXT")) {
            // in case logged in app 
        }
        else {
            let new_messages = []
            if (GlobalStoreService.get('isUserLoggedIn')) {

                switch (GlobalStoreService.get('userProfileType')) {
                    case 'SINGLE': {
                        new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.LOGIN_SUCCESS))
                        message_comp.initiateScenarioAfterLogin();
                        message_comp.closeLoginComp({})
                        break;
                    }
                    case 'MULTIPLE': {
                        message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
                        new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.LOGIN_SUCCESS))
                        new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT))

                        GlobalStoreService.set("loginViaOtp", true);
                        break;
                    }
                    default: {
                        // if no single or multiple case show a message that profile doesnt have any prepaid or postpaid number 
                        // so please type a new query
                        message_comp.closeLoginComp({})
                        new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR))
                    }
                }
            }
            else if(GlobalStoreService.get('loginNotAllowed')){
                new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.LOGIN_FAILED_PLEASE_RELOGIN))
                message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT,resetLoginState:true })
            }
            else {
                message_comp.closeLoginComp({})
                new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR))
            }
            message_comp.addNewMessages({ new_messages })
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/handle-user-login.service.js